<div class="dim-filter" [class.dim-filter-disabled]="disabled">
  @if (label) {
    <div class="dim-filter-label">{{ label | translate }}</div>
  }

  <div class="dim-mode-cards">
    @for (option of modeOptions; track trackByIndex($index)) {
      <label
        class="dim-mode-card"
        [class.selected]="mode === option.mode"
        [class.disabled]="disabled">
        <input
          type="radio"
          [name]="radioName"
          [checked]="mode === option.mode"
          [disabled]="disabled"
          (change)="onModeChange(option.mode)" />
          <span class="dim-mode-label">{{ option.label | translate }}</span>
        </label>
      }
    </div>

    @if (pickerVisible) {
      <mat-form-field appearance="outline" class="dim-picker">
        <mat-select
          multiple
          [ngModel]="selectValue"
          [disabled]="disabled"
          [placeholder]="pickerPlaceholder | translate"
          (ngModelChange)="onSelectionChange($event)">
          <mat-option>
            <ngx-mat-select-search
              [ngModel]="optionList.query"
              (ngModelChange)="onSearch($event)"
              [placeholderLabel]="'Search' | translate"
              [noEntriesFoundLabel]="'No options found' | translate">
              @if (hasSelection) {
                <app-multi-select-clear
                (cleared)="clearSelection()"></app-multi-select-clear>
              }
            </ngx-mat-select-search>
          </mat-option>
          @if (includeNone) {
            <mat-option [value]="noneSentinel">{{ noneLabel | translate }}</mat-option>
          }
          @for (option of optionList.display; track trackById($index, option)) {
            <mat-option [value]="option.id">
              {{ option.name | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
